import { UserRole } from 'features/user/ts/UserRole';

export const hasRequiredRoles = (userRoles: UserRole[], requiredRoles: UserRole[] | { name: UserRole['name'] }[]) => {
  if (requiredRoles.length === 0) return true;

  let isSuperadmin = false;
  let hasAllRoles = true;

  for (const requiredRole of requiredRoles) {
    if (
      !userRoles?.find(userRole => {
        if (userRole.name === 'super_admin') {
          isSuperadmin = true;
        }

        return userRole.name == requiredRole.name;
      })
    ) {
      hasAllRoles = false;
    }

    if (isSuperadmin) {
      break;
    }
  }

  return isSuperadmin || hasAllRoles;
};
